export default {
    values: {
        escalation : 'escalonamento',
        'must have degradation contribution between 0 and 100': 'deve ter contribuição de degradação entre 0 e 100',
        'Degradation Contribution': 'Contribuição de degradação'
    }
}
